<template>
	<div class="login-page">
		<!-- 语言选择栏 -->
		<div class="header">
			<img
				src="@/assets/images/logo_white.png"
				alt=""
				class="logoIcon"
			>
			<div class="language-selector">
				<SelectLanguage />
			</div>
		</div>

		<!-- 主要内容区域 -->
		<div class="main-content">
			<!-- 左侧服务器图示区域 -->
			<div class="server-section"> </div>

			<!-- 右侧登录表单区域 -->
			<div class="login-section">
				<div class="login-card">
					<h1 class="welcome-text">{{$t("欢迎使用交换机云平台")}}</h1>

					<!-- 登录方式切换 -->
					<div class="login-tabs">
						<button
							v-for="tab in loginTabs"
							:key="tab.id"
							:class="['tab-button', { active: activeTab === tab.id }]"
							@click="switchTab(tab.id)"
						>
							{{ $t(tab.label) }}
						</button>
					</div>

					<!-- 密码登录表单 -->
					<form
						v-if="activeTab === 'password'"
						@submit.prevent="handlePasswordLogin"
						class="login-form"
					>
						<div class="form-group">
							<input
								type="text"
								id="account"
								v-model="passwordLoginForm.account"
								:placeholder="$t('请输入手机号或邮箱')"
							/>
							<img
								src="@/assets/images/4.png"
								alt=""
								class="icon1"
							>
						</div>

						<div class="form-group">
							<input
								:type="showPassword ? 'text' : 'password'"
								id="password"
								v-model="passwordLoginForm.password"
								:placeholder="$t('请输入密码(6~12位字母+数字)')"
							/>
							<img
								src="@/assets/images/7.png"
								alt=""
								class="icon1"
							>
							<img
								v-show="showPassword"
								@click.stop="showPassword=!showPassword"
								src="@/assets/images/101.png"
								alt=""
								class="icon2"
							>
							<img
								v-show="!showPassword"
								@click.stop="showPassword=!showPassword"
								src="@/assets/images/2.png"
								alt=""
								class="icon2"
							>
						</div>

						<button
							type="submit"
							class="login-button"
							:disabled="isLoggingIn"
						>
							<span v-if="!isLoggingIn">{{$t("登录")}}</span>
							<span v-else>{{$t("登录中")}}...</span>
						</button>

						<div class="form-options">
							<label
								class="checkbox-label"
								style="opacity: 0;"
							>
								<input
									type="checkbox"
									v-model="passwordLoginForm.autoLogin"
								/>
								<span>{{$t("自动登录")}}</span>
							</label>
							<a
								href="#"
								class="forgot-password"
								@click.prevent="handleForgotPassword"
							>{{$t("忘记密码")}}</a>
						</div>
					</form>

					<!-- 手机号验证表单 -->
					<form
						v-else-if="activeTab === 'phone'"
						class="login-form"
					>
						<div class="form-group">
							<input
								type="tel"
								id="phone"
								v-model="phoneLoginForm.phone"
								:placeholder="$t('请输入手机号')"
								pattern="[0-9]{11}"
								@input="phoneLoginForm.phone=String(phoneLoginForm.phone).slice(0,11)"
							/>
							<img
								src="@/assets/images/4.png"
								alt=""
								class="icon1"
							>
						</div>

						<div class="form-group">
							<input
								type="text"
								id="phoneCode"
								style="padding-right:40%"
								v-model="phoneLoginForm.verificationCode"
								:placeholder="$t('请输入验证码')"
								@input="phoneLoginForm.verificationCode=String(phoneLoginForm.verificationCode).slice(0,6)"
							/>
							<span
								class="getCode pointer"
								:class="{dis:code_object.isCodeStart}"
								@click="code_object.getCodeApiHandleFn(phoneLoginForm.phone)"
							>
								{{ code_object.isCodeStart? (code_object.codePlac || '') : $t("获取验证码") }}
							</span>
							<img
								src="@/assets/images/9.png"
								alt=""
								class="icon1"
							>
						</div>

						<button
							type="submit"
							class="login-button"
							:disabled="isLoggingIn"
							@click="handlePhoneLogin"
						>
							<span v-if="!isLoggingIn">{{$t("登录")}}</span>
							<span v-else>{{$t("登录中")}}...</span>
						</button>

						<div class="form-options">
							<label
								class="checkbox-label"
								style="opacity: 0;"
							>
								<input
									type="checkbox"
									v-model="phoneLoginForm.autoLogin"
								/>
								<span>{{$t("自动登录")}}</span>
							</label>
							<a
								href="#"
								class="forgot-password"
								@click.prevent="handleForgotPassword"
							>{{$t("忘记密码")}}</a>
						</div>
					</form>

					<!-- 邮箱验证表单 -->
					<form
						v-else
						class="login-form"
					>
						<div class="form-group">
							<input
								type="email"
								id="email"
								v-model="emailLoginForm.email"
								:placeholder="$t('请输入邮箱')"
							/>
							<img
								src="@/assets/images/10.png"
								alt=""
								class="icon1"
							>
						</div>

						<div class="form-group">
							<input
								type="text"
								id="emailCode"
								style="padding-right:40%"
								v-model="emailLoginForm.verificationCode"
								:placeholder="$t('请输入验证码')"
								@input="emailLoginForm.verificationCode=String(emailLoginForm.verificationCode).slice(0,6)"
							/>
							<span
								class="getCode pointer"
								:class="{dis:email_code_object.isCodeStart}"
								@click="email_code_object.getCodeApiHandleFn(emailLoginForm.email,'email')"
							>
								{{ email_code_object.isCodeStart? (email_code_object.codePlac || '') : $t("获取验证码") }}
							</span>
							<img
								src="@/assets/images/9.png"
								alt=""
								class="icon1"
							>
						</div>

						<button
							type="submit"
							class="login-button"
							:disabled="isLoggingIn"
							@click="handleEmailLogin"
						>
							<span v-if="!isLoggingIn">{{$t('登录')}}</span>
							<span v-else>{{$t('登录中')}}...</span>
						</button>

						<div class="form-options">
							<label
								class="checkbox-label"
								style="opacity: 0;"
							>
								<input
									type="checkbox"
									v-model="emailLoginForm.autoLogin"
								/>
								<span>{{$t('自动登录')}}</span>
							</label>
							<a
								href="#"
								class="forgot-password"
								@click.prevent="handleForgotPassword"
							>{{$t('忘记密码')}}</a>
						</div>
					</form>

					<!-- 注册链接 -->
					<div class="register-section">
						<span>{{$t('没有账号，')}}</span>
						<a
							href="#"
							class="register-link"
							@click.prevent="handleRegister"
						>{{$t("去注册")}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
import SelectLanguage from '@/components/SelectLanguage.vue';
import { useUtils } from '@/common/utils/useUtils';
import { post } from '@/common/utils/useRequest';
import { useAreaCode } from '@/common/utils/useAreaCode';
import { useUserStore } from '@/store/user';
import { TryError } from '@/types/global';
import { useCode } from '@/common/utils/useCode';
const { err_msg, suc_msg } = useUtils();
const { codeObject } = useAreaCode();
const userStore = useUserStore();

import { useI18n } from 'vue-i18n';
const { t } = useI18n();
console.debug('t', t('年龄'));

// 类型定义
interface LoginTab {
	id: 'password' | 'phone' | 'email';
	label: string;
}

interface PasswordLoginForm {
	account: string;
	password: string;
	autoLogin: boolean;
}

interface PhoneLoginForm {
	phone: string;
	verificationCode: string;
	autoLogin: boolean;
}

interface EmailLoginForm {
	email: string;
	verificationCode: string;
	autoLogin: boolean;
}

interface FormErrors {
	[key: string]: string;
}

// 响应式数据
const activeTab = ref<'password' | 'phone' | 'email'>('password');
const showPassword = ref(false);
const isLoggingIn = ref(false);
const isCountingDown = ref(false);
const countdown = ref(60);

const code_object = ref(useCode(t));
code_object.value.codeType = 3;

const email_code_object = ref(useCode(t));
email_code_object.value.codeType = 3;

onUnmounted(() => {
	code_object.value.closeFn();
	email_code_object.value.closeFn();
});

// 登录方式标签
const loginTabs: LoginTab[] = reactive([
	{ id: 'password', label: '密码登录' },
	{ id: 'phone', label: '手机号验证' },
	{ id: 'email', label: '邮箱验证' }
]);

// 表单数据
const passwordLoginForm = reactive<PasswordLoginForm>({
	account: '',
	password: '',
	autoLogin: false
});

const phoneLoginForm = reactive<PhoneLoginForm>({
	phone: '',
	verificationCode: '',
	autoLogin: false
});

const emailLoginForm = reactive<EmailLoginForm>({
	email: '',
	verificationCode: '',
	autoLogin: false
});

// 表单错误信息
const passwordLoginErrors = reactive<FormErrors>({});
const phoneLoginErrors = reactive<FormErrors>({});
const emailLoginErrors = reactive<FormErrors>({});

// 切换登录方式
const switchTab = (tabId: 'password' | 'phone' | 'email') => {
	activeTab.value = tabId;
	// 清除表单错误
	clearFormErrors();
};

// 清除表单错误
const clearFormErrors = () => {
	Object.keys(passwordLoginErrors).forEach((key) => {
		passwordLoginErrors[key] = '';
	});
	Object.keys(phoneLoginErrors).forEach((key) => {
		phoneLoginErrors[key] = '';
	});
	Object.keys(emailLoginErrors).forEach((key) => {
		emailLoginErrors[key] = '';
	});
};

// 验证手机号格式
const validatePhone = (phone: string): boolean => {
	const phoneRegex = /^1[3-9]\d{9}$/;
	return phoneRegex.test(phone);
};

// 验证邮箱格式
const validateEmail = (email: string): boolean => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
};

// 验证密码格式
const validatePwd = (pwd: string): boolean => {
	const emailRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/;
	return emailRegex.test(pwd);
};

// 密码登录处理
const handlePasswordLogin = async () => {
	// 清除之前的错误
	clearFormErrors();

	// 简单验证
	let hasError = false;

	// console.debug('form', passwordLoginForm);

	if (!passwordLoginForm.account.trim()) {
		err_msg(t('请输入手机号或邮箱'));
		hasError = true;
	} else if (
		!validatePhone(passwordLoginForm.account.trim()) &&
		!validateEmail(passwordLoginForm.account.trim())
	) {
		err_msg(t('请正确输入手机号或邮箱'));
		hasError = true;
	} else if (!passwordLoginForm.password.trim()) {
		err_msg(t('请输入密码(6~12位字母+数字)'));
		hasError = true;
	} else if (!validatePwd(passwordLoginForm.password)) {
		err_msg(t('请输入正确的密码(6~12位字母+数字)'));
		hasError = true;
	}

	if (hasError) {
		return;
	}

	// 模拟登录请求
	isLoggingIn.value = true;
	try {
		// 这里可以替换为实际的API调用
		const res = await post('5c78dbfd977cf', {
			account: passwordLoginForm.account.trim(),
			account_type: validatePhone(passwordLoginForm.account.trim()) ? 1 : 2,
			password: passwordLoginForm.password.trim(),
			area_code: codeObject.phoneCode
		});
		suc_msg(t('登录成功！'));
		userStore.saveToken(res.data.userinfo.user_token);
		userStore.saveUserInfo(res.data.userinfo);
		userStore.getUserInfo();
		router.push('/home/gailan');
	} catch (error: any) {
		console.error('登录失败1:', error);
		err_msg(error.msg || t('登录失败'));
	} finally {
		isLoggingIn.value = false;
	}
};

// 手机号登录处理
const handlePhoneLogin = async () => {
	clearFormErrors();
	let hasError = false;

	if (!phoneLoginForm.phone.trim()) {
		err_msg(t('请输入手机号'));
		hasError = true;
	} else if (!validatePhone(phoneLoginForm.phone)) {
		err_msg(t('手机号格式不正确'));
		hasError = true;
	} else if (!phoneLoginForm.verificationCode.trim()) {
		err_msg(t('请输入验证码'));
		hasError = true;
	} /*  else if (phoneLoginForm.verificationCode.length !== 6) {
		phoneLoginErrors.verificationCode = '验证码为6位数字';
		hasError = true;
	} */

	if (hasError) return;

	isLoggingIn.value = true;
	try {
		const res = await post('5c78dca45ebc1', {
			account: phoneLoginForm.phone.trim(),
			account_type: 1,
			code: phoneLoginForm.verificationCode.trim(),
			type: '3',
			area_code: codeObject.phoneCode
		});
		suc_msg(t('登录成功！'));
		userStore.saveToken(res.data.userinfo.user_token);
		userStore.saveUserInfo(res.data.userinfo);
		userStore.getUserInfo();
		router.push('/home/gailan');
	} catch (error: any) {
		console.error('登录失败1:', error);
		err_msg(error.msg || t('登录失败'));
	} finally {
		isLoggingIn.value = false;
	}
};

// 邮箱登录处理
const handleEmailLogin = async () => {
	clearFormErrors();
	let hasError = false;

	if (!emailLoginForm.email.trim()) {
		err_msg(t('请输入邮箱'));
		hasError = true;
	} else if (!validateEmail(emailLoginForm.email)) {
		err_msg(t('邮箱格式不正确'));
		hasError = true;
	} else if (!emailLoginForm.verificationCode.trim()) {
		err_msg(t('请输入验证码'));
		hasError = true;
	} /*  else if (emailLoginForm.verificationCode.length !== 6) {
		emailLoginErrors.verificationCode = '验证码为6位数字';
		hasError = true;
	} */

	if (hasError) return;

	isLoggingIn.value = true;
	try {
		const res = await post('5c78dca45ebc1', {
			account: emailLoginForm.email.trim(),
			account_type: 2,
			code: emailLoginForm.verificationCode.trim(),
			type: '3',
			area_code: codeObject.phoneCode
		});
		suc_msg(t('登录成功！'));
		userStore.saveToken(res.data.userinfo.user_token);
		userStore.saveUserInfo(res.data.userinfo);
		userStore.getUserInfo();
		router.push('/home/gailan');
	} catch (error: any) {
		console.error('登录失败1:', error);
		err_msg(error.msg || t('登录失败'));
	} finally {
		isLoggingIn.value = false;
	}
};

// 忘记密码处理
const handleForgotPassword = () => {
	router.push('/wangjiPwd');
};

// 注册处理
const handleRegister = () => {
	router.push('/register');
};
</script>

<style scoped lang="scss">
.login-page {
	min-height: 100vh;
	background: url('@/assets/images/1.png') no-repeat left / cover;
	font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
	color: #333;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 40px;
	color: white;
}

.logo-section {
	display: flex;
	align-items: center;
}

.logo {
	display: flex;
	align-items: center;
	gap: 10px;
	font-size: 24px;
	font-weight: bold;
}

.cloud-icon {
	font-size: 28px;
}

.language-dropdown {
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.3);
	border-radius: 4px;
	color: white;
	padding: 8px 16px;
	font-size: 14px;
	cursor: pointer;
	backdrop-filter: blur(5px);
}

.language-dropdown option {
	color: #333;
	background: white;
}

.main-content {
	display: flex;
	min-height: calc(100vh - 80px);
	padding: 20px 230px;
	gap: 40px;
	align-items: center;
}

.server-section {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	min-height: 500px;
}

.server-container {
	display: flex;
	gap: 40px;
	align-items: flex-end;
	position: relative;
	z-index: 1;
}

.server {
	position: relative;
	width: 100px;
	height: 150px;
	perspective: 1000px;
}

.server-body {
	width: 100%;
	height: 100%;
	background: linear-gradient(135deg, #4a90e2 0%, #7ab8ff 100%);
	border-radius: 8px;
	box-shadow: 0 10px 30px rgba(0, 123, 255, 0.3),
		inset 0 0 20px rgba(255, 255, 255, 0.2);
	position: relative;
	overflow: hidden;
	animation: float 3s ease-in-out infinite;
	animation-delay: calc(var(--delay, 0) * 0.3s);
}

.server-body::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 20px;
	background: linear-gradient(
		90deg,
		transparent,
		rgba(255, 255, 255, 0.4),
		transparent
	);
	animation: shimmer 2s linear infinite;
}

.server-light {
	position: absolute;
	bottom: -20px;
	left: 50%;
	transform: translateX(-50%);
	width: 60px;
	height: 20px;
	background: linear-gradient(90deg, #00a8ff, #4cd137, #00a8ff);
	border-radius: 10px;
	filter: blur(2px);
	opacity: 0.8;
	animation: pulse 2s ease-in-out infinite;
	animation-delay: calc(var(--delay, 0) * 0.3s);
}

.server-1 {
	--delay: 1;
}

.server-2 {
	--delay: 2;
}

.server-3 {
	--delay: 3;
}

.server-4 {
	--delay: 4;
	display: none;
	/* 默认隐藏第四台服务器 */
}

.code-effect {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	gap: 8px;
	opacity: 0.7;
}

.code-line {
	height: 4px;
	background: rgba(255, 255, 255, 0.8);
	border-radius: 2px;
	animation: codeFlow 1.5s linear infinite;
	animation-delay: calc(var(--i, 0) * 0.2s);
}

.code-line:nth-child(1) {
	--i: 1;
	width: 100px;
}

.code-line:nth-child(2) {
	--i: 2;
	width: 80px;
}

.code-line:nth-child(3) {
	--i: 3;
	width: 120px;
}

.code-line:nth-child(4) {
	--i: 4;
	width: 60px;
}

.code-line:nth-child(5) {
	--i: 5;
	width: 90px;
}

.code-line:nth-child(6) {
	--i: 6;
	width: 70px;
}

.login-section {
	flex: 0 0 540px;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 500px;
}

.login-card {
	background: white;
	border-radius: 16px;
	padding: 40px;
	width: 100%;
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
	animation: slideIn 0.5s ease-out;
}

.welcome-text {
	text-align: center;
	color: #333;
	margin-bottom: 30px;
	font-size: 24px;
	font-weight: 600;
}

.login-tabs {
	display: flex;
	gap: 1px;
	padding: 4px;
	margin-bottom: 30px;
	border-bottom: 1px solid #eee;
}

.tab-button {
	flex: 1;
	padding: 12px;
	border: none;
	background: transparent;
	border-radius: 6px;
	font-size: 16px;
	font-weight: 500;
	color: #666;
	cursor: pointer;
	transition: all 0.3s ease;
	position: relative;
}

.tab-button.active {
	color: #3b6be9;
	font-weight: 600;

	&::after {
		content: '';
		display: block;
		width: 24px;
		height: 4px;
		background: #3b6be9;
		border-radius: 2px 2px 2px 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}
}

.login-form {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.form-group {
	display: flex;
	flex-direction: column;
	gap: 8px;
	position: relative;

	.icon1 {
		width: 18px;
		height: 18px;
		position: absolute;
		left: 24px;
		top: 50%;
		transform: translateY(-50%);
		z-index: 1;
		cursor: pointer;
	}

	.icon2 {
		width: 18px;
		height: 18px;
		position: absolute;
		right: 24px;
		top: 50%;
		transform: translateY(-50%);
		z-index: 1;
		cursor: pointer;
	}
}

.form-group label {
	font-size: 14px;
	font-weight: 500;
	color: #555;
}

.form-group input {
	padding: 16px 58px;
	border: 2px solid #e0e0e0;
	border-radius: 8px;
	font-size: 16px;
	transition: all 0.3s ease;
	position: relative;
}

.form-group input:focus {
	outline: none;
	border-color: #3b6be9;
	box-shadow: 0 0 0 3px rgba(26, 107, 179, 0.1);
}

.form-group input.error {
	border-color: #ff4757;
}

.error-message {
	color: #ff4757;
	font-size: 12px;
	margin-top: 4px;
}

.toggle-password {
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	cursor: pointer;
	font-size: 18px;
	color: #666;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.verification-input {
	display: flex;
	gap: 10px;
	align-items: center;
}

.verification-input input {
	flex: 1;
}

.get-code-btn {
	padding: 12px 20px;
	background: #3b6be9;
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	white-space: nowrap;
	transition: all 0.3s ease;
	min-width: 120px;
}

.get-code-btn:hover:not(:disabled) {
	background: #155a9c;
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(26, 107, 179, 0.3);
}

.get-code-btn:disabled {
	background: #ccc;
	cursor: not-allowed;
	transform: none;
	box-shadow: none;
}

.form-options {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0;
}

.checkbox-label {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #666;
	cursor: pointer;
}

.checkbox-label input[type='checkbox'] {
	width: 16px;
	height: 16px;
	cursor: pointer;
}

.forgot-password {
	color: #3b6be9;
	text-decoration: none;
	font-size: 14px;
	transition: color 0.3s ease;
}

.forgot-password:hover {
	color: #155a9c;
	text-decoration: underline;
}

.login-button {
	padding: 16px;
	background: linear-gradient(90deg, #6e94ff 0%, #3462e1 100%);
	box-shadow: 0px 2px 2px 1px rgba(32, 74, 191, 0.3),
		inset 0px 1px 1px 1px rgba(227, 239, 255, 0.36);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 18px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	margin-top: 10px;
	width: 100%;
}

.login-button:hover:not(:disabled) {
	background: linear-gradient(90deg, #6e94ff 0%, #3462e1 100%);
	box-shadow: 0px 2px 2px 1px rgba(32, 74, 191, 0.3),
		inset 0px 1px 1px 1px rgba(227, 239, 255, 0.36);
	transform: translateY(-2px);
	box-shadow: 0 8px 20px rgba(26, 107, 179, 0.3);
}

.login-button:disabled {
	background: #ccc;
	cursor: not-allowed;
	transform: none;
	box-shadow: none;
}

.register-section {
	text-align: center;
	margin-top: 25px;
	padding-top: 20px;
	font-size: 14px;
	color: #666;
}

.register-link {
	color: #3b6be9;
	text-decoration: none;
	font-weight: 500;
	transition: color 0.3s ease;
}

.register-link:hover {
	color: #155a9c;
	text-decoration: underline;
}

/* 动画 */
@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}

	50% {
		transform: translateY(-20px);
	}
}

@keyframes pulse {
	0%,
	100% {
		opacity: 0.5;
		transform: translateX(-50%) scale(1);
	}

	50% {
		opacity: 1;
		transform: translateX(-50%) scale(1.1);
	}
}

@keyframes shimmer {
	0% {
		transform: translateX(-100%);
	}

	100% {
		transform: translateX(100%);
	}
}

@keyframes codeFlow {
	0% {
		opacity: 0.3;
		transform: translateX(-20px);
	}

	50% {
		opacity: 0.8;
	}

	100% {
		opacity: 0.3;
		transform: translateX(20px);
	}
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateX(20px);
	}

	to {
		opacity: 1;
		transform: translateX(0);
	}
}

.logoIcon {
	width: 163px;
	height: 32px;
}

:deep(.language_box) {
	width: 144px !important;

	.el-select__wrapper {
		height: 36px !important;
		background: rgba(246, 247, 249, 0.2) !important;
		border-radius: 6px 6px 6px 6px;
		border-width: 0 !important;
		box-shadow: none !important;
		color: #fff;

		.el-select__input {
			color: #fff !important;
			&::placeholder {
				color: #fff !important;
			}
		}
	}
}

.getCode {
	position: absolute;
	right: 24px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	color: #2973fd;

	&.dis {
		color: #999;
	}
}
</style>